export default __webpack_public_path__ + "static/media/naiycgirl.78e61b94.png";